import React from 'react'

import { LocalizedSlugsProvider } from '../../hooks/useLocalizedSlugs'
import NavigationMenu, { NavigationMenuProps } from '../organisms/navigation-menu'
import Footer, { FooterProps } from '../organisms/footer'
import styled from '@emotion/styled'

type LayoutBaseProps = {
  children: React.ReactElement[]
  menu: NavigationMenuProps
  footer: FooterProps
}

export const LayoutBase = ({ children, menu, footer }: LayoutBaseProps) => {
  return (
    <>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-T8SNWCX"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>
      <LocalizedSlugsProvider>
        {menu && menu.logo && menu.items && menu.ctaButton && <NavigationMenu {...menu} />}
        <MainWithMenuOffset role="main">{children}</MainWithMenuOffset>
        {footer && <Footer {...footer} />}
      </LocalizedSlugsProvider>
    </>
  )
}

const MainWithMenuOffset = styled.main`
  padding-top: var(--navigation-height);
`
